<template>
  <div
    :class="`boost-filter__sort-by ${mainClass}`"
    js-boost-filter="sortBy"
  >
    <span
      v-if="!isMobile"
      class="boost-filter__facets-title"
      v-text="$string('collection.sort_by')"
    />
    <span
      v-if="!isMobile"
      class="
        boost-filter__sort-by-option
        text-utility-capitalized-m
      "
      v-text="
        hasSortOption('sort')
          ? sortOption.label
          : $string('collection.sort_by_options.recommended')
      "
    />
    <button
      :class="[
        `${mainClass}__control`,
        {
          'text-utility-capitalized-m-bold': isMobile,
          'text-heading-m boost-filter__sort-by-label': !isMobile
        }
      ]"
      for="sort-by"
      :tabindex="0"
      type="button"
      @click="handleSelectLabelClick"
    >
      <span
        v-if="isMobile"
        v-text="$string('collection.sort')"
      />

      <icon-arrow-down-filled />
    </button>

    <div
      v-if="isMobile && sortOption.label"
      class="boost-facet-mobile__active-values"
      v-text="sortOption.label"
    />

    <ul
      :class="`
      boost-filter__sort-by-inner
      ${mainClass}__content
    `"
    >
      <li
        v-for="sort of sortByOptions"
        :key="sort.id"
        class="boost-facet__value-wrapper"
        :class="{ 'boost-facet-mobile__value-wrapper': isMobile }"
      >
        <button
          :id="sort.id"
          class="
            boost-filter__sort-by--option
            text-utility-capitalized-m
            boost-facet__value
          "
          :class="{
            [$class('active')]: hasSortOption(sort.id),
            'boost-facet-mobile__value': isMobile
          }"
          type="button"
          :value="sort.id"
          js-boost-filter="sortByOption"
          @click="handleSortByChange"
        >
          <div
            class="boost-facet__checkbox"
          >
            <icon-tick />
          </div>

          <span v-text="sort.label" />
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import IconArrowDownFilled from '~icons/direction/arrow/down-filled.svg'
import IconTick from '~icons/misc/tick.svg'

export default {
  name: 'BoostSortBy',

  components: {
    IconArrowDownFilled,
    IconTick,
  },

  props: {
    sortOption: {
      type: Object,
      default: () => ({}),
    },
    sortByOptions: {
      type: Array,
      default: () => [],
    },
    dataChoices: {
      type: String,
      default: '',
    },
  },

  emits: {
    'handle-sort-by-change': (payload) => typeof payload === 'object',
  },

  computed: {

    /**
    * Map Vuex state.
    */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
    * Returns main class.
    * @returns {String}
    */
    mainClass() {
      return this.isMobile ? 'boost-facet-mobile' : 'boost-facet'
    },
  },

  methods: {

    /**
     * Returns sort option status.
     * @param {String} key - Sort key.
     * @returns {Boolean}
     */
    hasSortOption(key) {
      const isRecommended = key === 'sort'
        ? this.sortOption.id === 'recommended'
        : this.sortOption.id === 'recommended' && key === 'recommended'

      return this.dataChoices.includes(key) ||
        (!this.dataChoices.includes(key) && isRecommended)
    },

    /**
     * Toggle active class on 'sort by' label on click.
     * @param {Object} event - Click event.
     */
    handleSelectLabelClick(event) {
      const sortBy = event.currentTarget.parentNode
      const options = sortBy.querySelectorAll('[js-boost-filter="sortByOption"]')

      if (!sortBy.classList.contains(this.$class('active'))) {
        const facets = document.querySelectorAll('[js-boost-facet="facet"]')

        facets.forEach((facet) => {
          const values = facet.querySelectorAll('[js-boost-facet="value"]')

          facet.classList.remove(this.$class('active'))
          values.forEach((value) => value.setAttribute('tabindex', -1))
        })

        sortBy.classList.add(this.$class('active'))
        options.forEach((option) => option.setAttribute('tabindex', 0))
        return
      }

      sortBy.classList.remove(this.$class('active'))
      options.forEach((option) => option.setAttribute('tabindex', -1))
    },

    /**
     * Toggle active class on 'sort by' label on click.
     * @param {Object} event - Click event.
     */
    handleSortByChange(event) {
      const sortBy = document.querySelector('[js-boost-filter="sortBy"]')

      if (!this.isMobile) {
        sortBy.classList.remove(this.$class('active'))
      }

      this.$emit('handle-sort-by-change', event)
    },
  },
}
</script>
